import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { POSTS } from "../blogData";
import SEO from "../components/SEO";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function BlogPostPage() {
  const { id } = useParams();
  const post = POSTS.find((p) => p.id === id);
  const others = POSTS.filter((p) => p.id !== id).slice(0, 2);

  useEffect(() => { window.scrollTo(0, 0); }, [id]);

  if (!post) {
    return (
      <div className="blog-page">
        <Nav />
        <div className="container" style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 20, paddingTop: 120 }}>
          <h2 style={{ fontFamily: "var(--font-display)" }}>Article not found.</h2>
          <Link to="/blog" className="sp-cta-btn" style={{ textDecoration: "none" }}>← Back to Insights</Link>
        </div>
        <Footer />
      </div>
    );
  }

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `https://ovarddigital.com/blog/${post.id}`,
    "url": `https://ovarddigital.com/blog/${post.id}`,
    "headline": post.title,
    "description": post.excerpt,
    "image": post.hero,
    "datePublished": post.date,
    "author": {
      "@id": "https://ovarddigital.com/#organization"
    },
    "publisher": {
      "@id": "https://ovarddigital.com/#organization"
    },
    "isPartOf": { "@id": "https://ovarddigital.com/#website" },
    "keywords": `${post.category}, digital marketing, OVARD Digital, brand growth`,
    "articleSection": post.category,
    "inLanguage": "en-IN"
  };

  return (
    <div className="blog-page">
      <SEO
        title={post.title}
        description={post.excerpt}
        canonical={`/blog/${post.id}`}
        ogImage={post.hero}
        ogType="article"
        schema={articleSchema}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Insights", path: "/blog" },
          { name: post.title, path: `/blog/${post.id}` }
        ]}
      />
      <Nav />

      {/* Hero */}
      <section className="bp-hero">
        <div className="bp-hero-img" style={{ backgroundImage: `url(${post.hero})` }} />
        <div className="bp-hero-overlay" />
        <div className="bp-hero-grain" aria-hidden="true" />
        <div className="container bp-hero-content">
          <Link to="/blog" className="bp-back">← Insights</Link>
          <span className="bp-category">{post.category}</span>
          <h1 className="bp-title">{post.title}</h1>
          <div className="bp-meta">
            <span>{post.date}</span>
            <span className="bp-meta-sep">·</span>
            <span>{post.readTime}</span>
          </div>
        </div>
      </section>

      {/* Article body */}
      <article className="bp-article">
        <div className="container bp-article-inner">
          {post.body.map((block, i) => {
            if (block.type === "h2") return <h2 key={i} className="bp-h2">{block.text}</h2>;
            if (block.type === "cta") return (
              <div key={i} className="bp-cta-block">
                <p className="bp-cta-text">{block.text}</p>
                <Link to="/contact" className="bp-cta-btn">
                  Start a conversation
                  <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
                    <path d="M8 1L13 5L8 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13 5H1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
                  </svg>
                </Link>
              </div>
            );
            return <p key={i} className="bp-p">{block.text}</p>;
          })}
        </div>
      </article>

      {/* More articles */}
      {others.length > 0 && (
        <section className="bp-more">
          <div className="container">
            <h3 className="bp-more-heading">More from OVARD</h3>
            <div className="bp-more-grid">
              {others.map((p) => (
                <Link to={`/blog/${p.id}`} className="blog-card" key={p.id}>
                  <div className="blog-card-img-wrap">
                    <img src={p.hero} alt={`${p.title} — OVARD Digital`} className="blog-card-img" loading="lazy" />
                    <span className="blog-card-category">{p.category}</span>
                  </div>
                  <div className="blog-card-body">
                    <div className="blog-card-meta">
                      <span>{p.date}</span>
                      <span className="blog-card-meta-sep">·</span>
                      <span>{p.readTime}</span>
                    </div>
                    <h2 className="blog-card-title">{p.title}</h2>
                    <p className="blog-card-excerpt">{p.excerpt}</p>
                    <span className="blog-card-cta">
                      Read article
                      <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
                        <path d="M8 1L13 5L8 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M13 5H1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
                      </svg>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      <Footer />
    </div>
  );
}
